import * as React from 'react';
import * as PropTypes from 'prop-types';
import { SanitizedRender } from '@reverbdotcom/discovery-ui';
import UrlHelpers from '../shared/url_helpers';

function TaxWillBeAddedNotice(props) {
  if (props.showNotice) {
    return (
      <div className="alert-box alert-box--blue size-90">
        <SanitizedRender
          allowedTags={['a']}
          html={I18n.t('js.productBundles.taxWillBeAddedNotice', {
            shopTaxPolicyPath: UrlHelpers.shopTaxPolicyPath,
          })}
        />
      </div>
    );
  }
  return null;
}

TaxWillBeAddedNotice.propTypes = {
  showNotice: PropTypes.bool.isRequired,
};

export default TaxWillBeAddedNotice;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/tax_will_be_added_notice.jsx